<div class="panel">
  <div class="mb-3 flex items-center justify-between">
    <h3 class="text-sm font-semibold">Change history</h3>
    <span *ngIf="total" class="text-xs text-gray-400">{{ total }} {{ total === 1 ? 'entry' : 'entries' }}</span>
  </div>
  <app-audit-log-table
    [rows]="rows"
    [loading]="loading && !rows.length"
    [showResource]="false"
    emptyMessage="No changes recorded for this record yet."
    (view)="selected = $event"
  />
  <div *ngIf="rows.length < total" class="mt-3 text-center">
    <button
      type="button"
      class="btn rounded-xl border border-gray-200 px-4 py-2 text-sm shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:hover:bg-white/5"
      [disabled]="loading"
      (click)="loadMore()"
    >
      {{ loading ? 'Loading…' : 'Show older changes' }}
    </button>
  </div>
  <app-audit-entry-drawer [row]="selected" (closed)="selected = null" />
</div>
